export enum GoalStatus {
  on_track = "On Track",
  behind = "Behind",
  at_risk = "At Risk",
}

export enum ProgressStatus {
  on_track = "On Track",
  behind = "Behind",
  at_risk = "At Risk",
}

export enum ProgramStatus {
  active = "Active",
  paused = "Paused",
}

export enum UpdateStatus {
  pending = "pending",
  applied = "applied",
  ignored = "ignored",
}

export enum SuggestionTypeEnum {
  program_completion_percentage = "program_completion_percentage",
  program_status = "program_status",
  program_budget_spent = "program_budget_spent",
  goal_status = "goal_status",
  goal_update = "goal_update",
  milestone_status = "milestone_status",
  milestone_update = "milestone_update",
}

export const StatusLabelMap: Record<string, string> = {
  on_track: "On Track",
  behind: "Behind",
  at_risk: "At Risk",
  active: "Active",
  paused: "Paused",
};

export const SuggestionType: Record<string, string> = {
  program_completion_percentage: "Program Completion Percentage",
  program_status: "Program Status",
  program_budget_spent: "Program Budget Spent",
  goal_status: "Goal Status",
  goal_update: "Goal Update",
  milestone_status: "Milestone Status",
  milestone_update: "Milestone Update",
};
